import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";

const DocumentTitlesPanel = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        padding: "12px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          fontSize: "14px",
          fontWeight: 600,
          color: "#0f172a",
          marginBottom: 12,
        }}
      >
        {i18n.t("AudioPanel.DocumentTitles")}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8F8F8F",
          fontSize: "13px",
        }}
      >
        {/* Content will be added here */}
      </div>
    </div>
  );
};

DocumentTitlesPanel.propTypes = {};

export default DocumentTitlesPanel;
